import {
  OVEntity,
  OVField,
  OVForm,
  OVSearchable,
} from '@ov-suite/ov-metadata';

@OVEntity('WaveInstance', 'warehouselink', '',)
@OVForm([
  ['#Picking Waves'],
  ['#Start'],
  ['description'],
])
export class WaveInstance {
  @OVField({
    type: 'string',
    title: 'Unique ID',
    sidebar: true,
    generated: true,
    readonly: true
  })
  id: number;

  @OVSearchable()
  @OVField({
    type: 'string',
    title: 'Wave Name',
    placeholder: 'Required',
    required: true
  })
  waveName: string;

  @OVSearchable()
  @OVField({
    type: 'date-time',
    title: 'Start Date',
    placeholder: 'Required',
    required: false
  })
  startDate: string;

  @OVSearchable()
  @OVField({
    type: 'date-time',
    title: 'End Date',
    placeholder: 'Required',
    required: false
  })
  endDate: string;

  @OVSearchable()
  @OVField({
    type: 'boolean',
    title: 'Occurrence',
    placeholder: 'Required',
    required: false
  })
  occurrence: boolean;

  @OVField({
    type: 'recurrence',
    title: 'Description',
    required: false,
  })
  recurrence?: {};

  @OVField({
    type: 'date',
    title: 'Planned Date',
    required: true
  })
  plannedDate: string;

  @OVField({
    type: 'date',
    generated: true,
    readonly: true
  })
  completedDate?: Date;

  @OVField({
    type: 'string',
    title: 'Description',
    required: true
  })
  description: string;
}
